import type { OcSheetV1Props } from "../SheetV1.types.g";
import { stack } from "../stack/global.svelte";
import { findInstance } from "../stack/stack.utils";
import { sheetProps } from "../utils/props";
import { scopeInfo, statePropConfig, type SheetNavScope } from "./scope.js";
import { navScope } from "./scope.js";

const log = /*           */ navScope.scope("state-handler");

/**
 *
 *
 *
 *
 */
export const initStatePropsUpdater: (scope: SheetNavScope) => void = (scope) => {
  if (import.meta.env.DEV) log.info("init state handling integration", history.length);

  /*                                                                                */
  /*                                          */

  $effect(() => {
    const instance = findInstance(stack.current);
    if (!instance) {
      if (import.meta.env.DEV) log.info("no sheet instance found, skip update");
      return;
    }

    const props = Object.fromEntries(sheetProps.map((p) => [p, instance[p]])) as OcSheetV1Props;

    if (import.meta.env.DEV) log.info("open sheet props changed", props, history.length);
    const state = scope.state();

    /*                                                                  */
    if (state.empty || !props) {
      if (import.meta.env.DEV) log.info("no sheet state in scope, or empty props, skip update");
      return;
    }

    /*                                                   */
    /*                                                                  */
    if (import.meta.env.DEV) log.info("updating state config", props);
    state.set(statePropConfig, props);
    scope.replace(scopeInfo);
  });
};
